/* Home — hero. Giant "Dozzee" word drawn on a canvas; the photo/video shows through the letters.
   On scroll the word scales up (from the bowl of the "o") until the video fills the screen. */
(function () {
  var F = '"Libre Caslon Display", Georgia, serif';
  var WORD = 'Dozzee';

  function strokeOf(fs) {
    var s = Math.round(Math.min(fs, 500)), c = document.createElement('canvas');
    c.width = Math.ceil(s * 1.3); c.height = Math.ceil(s * 1.3);
    var x = c.getContext('2d'); x.direction = 'ltr'; x.textAlign = 'left'; x.font = '400 ' + s + 'px ' + F;
    var m = x.measureText('o'), ox = Math.ceil(m.actualBoundingBoxLeft || 0) + 4, by = Math.ceil(m.actualBoundingBoxAscent || s * 0.55) + 4;
    x.fillStyle = '#000'; x.fillText('o', ox, by);
    var midY = Math.round(by - ((m.actualBoundingBoxAscent || s * 0.55) - (m.actualBoundingBoxDescent || 0)) / 2);
    var row = x.getImageData(0, midY, c.width, 1).data, a = -1, b = -1;
    for (var i = 0; i < c.width; i++) { if (row[i * 4 + 3] > 127) { if (a < 0) a = i; b = i; } else if (a >= 0) break; }
    var k = fs / s;
    if (a < 0) return { cx: m.width * 0.18 * k, cy: (by - midY) * k, w: fs * 0.14 };
    return { cx: ((a + b + 1) / 2 - ox) * k, cy: (by - midY) * k, w: (b + 1 - a) * k };
  }

  function Hero(sec) {
    var D = window.Dozzee || {};
    var one = function (s) { return sec.querySelector(s); };
    var q = function (s) { return Array.prototype.slice.call(sec.querySelectorAll(s)); };
    var reduce = !!D.reduce;
    var self = this, alive = true, ctx = null, splits = [], offs = [];
    var on = function (el, ev, fn, o) { if (!el) return; el.addEventListener(ev, fn, o); offs.push(function () { el.removeEventListener(ev, fn, o); }); };

    var canvas = one('[data-hero-canvas]'), stage = one('[data-hero]');
    var H = { hero: stage, canvas: canvas, cx2: canvas.getContext('2d'), s: 1, rise: Array.from(WORD, function () { return { y: 1, a: 0 }; }) };

    function layout() {
      if (!H.hero) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2), w = H.hero.clientWidth, h = H.hero.clientHeight;
      if (!w || !h) return;
      H.canvas.width = Math.round(w * dpr); H.canvas.height = Math.round(h * dpr);
      var ref = 100, tr = -0.012, c = H.cx2;
      c.setTransform(1, 0, 0, 1, 0, 0); c.direction = 'ltr'; c.textAlign = 'left'; c.font = '400 ' + ref + 'px ' + F;
      var adv = Array.from(WORD).map(function (ch) { return c.measureText(ch).width; });
      var m = c.measureText(WORD), asc = m.actualBoundingBoxAscent || ref * 0.75, desc = m.actualBoundingBoxDescent || 0;
      var total = adv.reduce(function (p, n) { return p + n; }, 0) + tr * ref * (WORD.length - 1);
      var fs = (w * 0.9) / total * ref; fs = Math.min(fs, (h * 0.42) / ((asc + desc) / ref));
      var k = fs / ref, x0 = (w - total * k) / 2, base = h * 0.43 + ((asc - desc) * k) / 2;
      var band = one('[data-hero-band]');
      if (band) band.style.top = Math.round(base + Math.max(16, h * 0.028)) + 'px';
      var xs = [], x = x0;
      for (var i = 0; i < WORD.length; i++) { xs.push(x); x += adv[i] * k + tr * fs; }
      var st = strokeOf(fs), oi = Math.max(0, WORD.indexOf('o'));
      H.L = { w: w, h: h, dpr: dpr, fs: fs, xs: xs, base: base, cx: xs[oi] + st.cx, cy: base - st.cy, S: (w / Math.max(4, st.w)) * 1.35 };
      draw();
    }

    function draw() {
      if (!H.L) return;
      var c = H.cx2, L = H.L, s = H.s;
      c.setTransform(L.dpr, 0, 0, L.dpr, 0, 0); c.globalCompositeOperation = 'source-over'; c.globalAlpha = 1; c.clearRect(0, 0, L.w, L.h);
      if (!H.bg || H.bgH !== L.h) {
        var g = c.createLinearGradient(0, 0, 0, L.h);
        g.addColorStop(0, '#F4F0E6'); g.addColorStop(0.5, '#E5EAD6'); g.addColorStop(1, '#DCE4CA');
        H.bg = g; H.bgH = L.h;
      }
      c.fillStyle = H.bg; c.fillRect(0, 0, L.w, L.h);
      var fade = Math.min(1, Math.max(0, Math.log(Math.max(1, s)) / Math.log(4)));
      if (fade > 0) { c.globalAlpha = fade; c.fillStyle = '#F4F0E6'; c.fillRect(0, 0, L.w, L.h); c.globalAlpha = 1; }
      c.translate(L.cx, L.cy); c.scale(s, s); c.translate(-L.cx, -L.cy);
      c.globalCompositeOperation = 'destination-out'; c.direction = 'ltr'; c.textAlign = 'left';
      c.font = '400 ' + L.fs + 'px ' + F; c.textBaseline = 'alphabetic';
      for (var i = 0; i < L.xs.length; i++) {
        var r = H.rise[i]; if (r.a <= 0.001) continue;
        c.globalAlpha = Math.min(1, r.a); c.fillText(WORD[i], L.xs[i], L.base + r.y * L.fs * 0.3);
      }
      c.globalAlpha = 1; c.globalCompositeOperation = 'source-over';
    }

    /* ----- media: video starts at 3s and loops back there; reduced motion shows the poster ----- */
    var vid = one('[data-hero-video]');
    if (vid) {
      if (reduce) { vid.style.display = 'none'; }
      else {
        var START = 3;
        vid.muted = true; vid.defaultMuted = true; vid.loop = false; vid.playsInline = true;
        var toStart = function () { try { vid.currentTime = START; } catch (e) {} };
        var play = function () { var p = vid.play(); if (p && p.catch) p.catch(function () {}); };
        on(vid, 'loadedmetadata', function () { if (vid.currentTime < START) toStart(); });
        on(vid, 'timeupdate', function () { if (vid.duration && vid.currentTime >= vid.duration - 0.3) toStart(); });
        on(vid, 'ended', function () { toStart(); play(); });
        // Load the video only after the page itself has loaded (keeps the first screen fast);
        // phones get the smaller rendition. The poster shows until then.
        var startVideo = function () {
          if (!alive || vid.getAttribute('src')) return;
          var small = window.matchMedia('(max-width: 759px)').matches || (navigator.connection && navigator.connection.saveData);
          var src = (small && vid.getAttribute('data-src-sm')) || vid.getAttribute('data-src');
          if (!src) return;
          vid.preload = 'auto'; vid.src = src + '#t=' + START; play();
        };
        var later = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(startVideo, { timeout: 2500 }); };
        if (document.readyState === 'complete') later(); else on(window, 'load', later);
      }
    }

    /* ----- band colour ----- */
    function paint(c) {
      if (!c) return;
      q('[data-band-key]').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-band-key') === c.key); });
    }
    if (D.getColour) paint(D.getColour());
    on(document, 'dozzee:colour', function (e) { paint(e.detail && e.detail.colour); });

    /* ----- first paint ----- */
    layout();
    var pw = one('[data-hero-photo-wrap]'); if (pw) pw.style.opacity = '1';
    on(window, 'resize', function () { if (!window.ScrollTrigger) layout(); });
    if (document.fonts && document.fonts.load) {
      Promise.all([document.fonts.load('400 100px "Libre Caslon Display"'), document.fonts.load('600 16px "Montserrat"')])
        .then(function () { if (alive) layout(); }, function () {});
    }

    function showStatic() {
      H.rise.forEach(function (r) { r.a = 1; r.y = 0; });
      sec.classList.add('is-static');
      layout();
    }

    if (reduce) { showStatic(); }
    else {
      var started = false;
      var fb = setTimeout(function () { if (!started && alive) showStatic(); }, 10000);
      offs.push(function () { clearTimeout(fb); });
      if (D.gsap) D.gsap(function (gsap, ST, Split) {
        if (!alive) return;
        started = true; clearTimeout(fb);
        var onRefreshInit = function () { layout(); };
        ST.addEventListener('refreshInit', onRefreshInit);
        offs.push(function () { ST.removeEventListener('refreshInit', onRefreshInit); });
        layout();

        ctx = gsap.context(function () {
          var cap = one('[data-hero-cap]'), header = document.querySelector('[data-header]');
          var title = Split.create(one('[data-hero-title]'), { type: 'lines', mask: 'lines' }); splits.push(title);

          var intro = gsap.timeline({ delay: 0.1, onUpdate: draw })
            .to(H.rise, { y: 0, a: 1, duration: 1.4, ease: 'expo.out', stagger: 0.075 }, 0)
            .fromTo(q('[data-hero-photo]'), { scale: 1.4 }, { scale: 1, duration: 2.4, ease: 'expo.out' }, 0)
            .from(one('[data-band-in]'), { y: 170, rotation: 10, scale: 0.8, duration: 1.6, ease: 'expo.out' }, 0.55)
            .from(q('[data-hero-in]'), { y: 24, opacity: 0, duration: 1, stagger: 0.08, ease: 'power3.out' }, 0.7);
          if (header && window.scrollY < 40) {
            header.style.transition = 'none';
            intro.from(header, { y: -90, opacity: 0, duration: 1, ease: 'expo.out', clearProps: 'transform,opacity', onComplete: function () { header.style.transition = ''; } }, 0.6);
          }

          var arrow = one('[data-hero-arrow]');
          if (arrow) gsap.to(arrow, { y: 5, duration: 0.9, yoyo: true, repeat: -1, ease: 'sine.inOut' });
          gsap.to(one('[data-band-float]'), { y: -14, duration: 2.6, yoyo: true, repeat: -1, ease: 'sine.inOut' });

          var par = one('[data-band-par]');
          var px = gsap.quickTo(par, 'x', { duration: 0.9, ease: 'power3' }), py = gsap.quickTo(par, 'y', { duration: 0.9, ease: 'power3' }), pr = gsap.quickTo(par, 'rotation', { duration: 0.9, ease: 'power3' });
          on(stage, 'pointermove', function (e) {
            var nx = e.clientX / window.innerWidth - 0.5, ny = e.clientY / window.innerHeight - 0.5;
            px(nx * 26); py(ny * 12); pr(nx * 2.5);
          });

          gsap.timeline({ onUpdate: draw, scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.6, invalidateOnRefresh: true } })
            .to(one('[data-hero-ui]'), { opacity: 0, y: -40, duration: 0.14, ease: 'power1.in' }, 0)
            .to(one('[data-hero-band]'), { y: function () { return -window.innerHeight * 0.75; }, rotation: -22, opacity: 0, duration: 0.32, ease: 'power2.in' }, 0)
            .to(H, { s: function () { return H.L ? H.L.S : 40; }, duration: 0.6, ease: 'power3.in' }, 0.06)
            .fromTo(one('[data-hero-photo-wrap]'), { scale: 1.2 }, { scale: 1, duration: 0.64, ease: 'power2.out' }, 0.06)
            .set(canvas, { autoAlpha: 0 }, 0.665)
            .to(one('[data-hero-shade]'), { opacity: 0, duration: 0.12 }, 0.68)
            .set(cap, { autoAlpha: 1 }, 0.7)
            .from(title.lines, { yPercent: 105, duration: 0.14, stagger: 0.035, ease: 'power3.out' }, 0.7)
            .from(one('[data-hero-side]'), { opacity: 0, y: 30, duration: 0.12, ease: 'power2.out' }, 0.8)
            .to({}, { duration: 0.12 }, 0.88);
        }, sec);
        on(window, 'load', function () { ST.refresh(); });
        var rf = setTimeout(function () { ST.refresh(); }, 800);
        offs.push(function () { clearTimeout(rf); });
      });
    }

    this.destroy = function () {
      alive = false;
      offs.forEach(function (f) { try { f(); } catch (e) {} });
      if (ctx) ctx.revert();
      splits.forEach(function (s) { try { s.revert(); } catch (e) {} });
    };
  }

  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-section-type="home-hero"]')).forEach(function (sec) {
      if (sec._hmHero) return;
      sec._hmHero = new Hero(sec);
    });
  }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-section-type="home-hero"]')).forEach(function (sec) {
      if (sec._hmHero) { sec._hmHero.destroy(); sec._hmHero = null; }
    });
  });
})();
